module.exports = __webpack_public_path__ + "img/center_center.376581d7.svg";